export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100">
          <i className="ri-smartphone-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-3">
          随时随地 畅快观影
        </h2>
        <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
          成全影院全面支持手机、平板、电脑多端同步观影。移动端专属优化，流量消耗更低，画质不打折。无论通勤路上还是睡前时光，打开成全影院即刻享受高清流畅的观影体验。
        </p>
        <a
          href="#index"
          onClick={(e) => {
            e.preventDefault();
            document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-secondary-500 hover:bg-secondary-600 text-white rounded-md font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
        >
          <i className="ri-download-2-line text-lg"></i>
          立即体验
        </a>
      </div>
    </section>
  );
}